export const PREMIUM_TOOLTIP_MESSAGE =
  'This is the monthly premium of the selected offer. You will not be charged this until you confirm payment options with your agent.';
